export default {
  common: {
    colon: '：',
    cancel: '取消',
    confirm: '確認',
    back: '返回',
    noBooking: '未找到預約資訊',
    placeholderNote: '畫面待補充（等待設計圖）'
  },
  views: {
    trainList: {
      vehicleInfo: '車輛資訊',
      ticketName: '新幹線車票',
      travelDate: '參加日期：',
      route: '出發和到達：',
      ticketCount: '預約數量：',
      adult: '成人票',
      child: '兒童票',
      trainType: '車型',
      seatClass: '座位類型：',
      preOrderNote:
        '*預約超過一個月訂單時，出票將延至乘車日的前一個月，屆時可在首頁查看結果',
      selectStation: '選擇車站',
      from: '出發',
      to: '到達',
      selectTrain: '選擇車次',
      select: '選擇',
      book: '預訂',
      seatAvailable: '餘票充足',
      seatLimited: '餘票不足',
      soldOut: '票已售罄',
      notOnSale: '尚未開售',
      durationFormat: '{{hours}}時{{minutes}}分',
      noTrains: '該時段暫無車次'
    },
    seat: {
      title: '請選擇座位',
      ticketCount: '預約數量',
      adult: '成人票',
      preference: '位置偏好',
      window: '優先靠窗',
      aisle: '優先靠走道',
      adjacent: '優先相鄰座',
      next: '下一步'
    },
    confirm: {
      trainConfirm: '車次確認',
      ticketName: '新幹線車票',
      route: '出發和到達：',
      travelDate: '參加日期：',
      ticketCount: '預約數量：',
      trainType: '車型：',
      seatClass: '座位類型：',
      preference: '位置偏好：',
      confirmSelect: '確認選擇'
    },
    submitted: {
      title: '預約已提交',
      thanks: '感謝您的預訂，請返回首頁查看出票結果',
      thanksSub: '*乘車前一個月開始出票，請耐心等待',
      ticketName: '新幹線車票',
      route: '出發和到達：',
      travelDate: '參加日期：',
      ticketCount: '預約數量：',
      trainType: '車型：',
      seatClass: '座位類型：',
      preference: '位置偏好：',
      backHome: '返回首頁',
      noticeTitle: '注意事項',
      notice1:
        '每日23:30~05:30（日本時間）系統維護期間暫停出票，維護結束後自動出票，結果可在首頁查看。',
      notice2:
        '出票失敗時，首頁票券將顯示「餘票不足」，請點擊底部「預訂車票」按鈕重新操作。'
    }
  }
};
